var v1="<div class=\"map\" ng-attr-id=\"{{vm.mapId}}\"></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/lbMap/lbMapTemplate.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbMap/lbMapTemplate.html
// module id = 383
// module chunks = 0